import basicController from "servicestack/basic.controller.properties";

export default class VendorGroupDashboardHeaderController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
  }
}
